import type { RecurringTournament } from '@ps/web-shared-api-types/v0/SwHomeGames';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Day, TXTCLI_Month, TXTCLI_Weekly } from './recurringOptions.messages.json';

const recurringOptions = [
  {
    text: <Translation {...TXTCLI_Day} />,
    value: 'HG_RECURRING_DAILY' as RecurringTournament['recurringPatternType']
  },
  {
    text: <Translation {...TXTCLI_Weekly} />,
    value: 'HG_RECURRING_WEEKLY' as RecurringTournament['recurringPatternType']
  },
  {
    text: <Translation {...TXTCLI_Month} />,
    value: 'HG_RECURRING_MONTHLY' as RecurringTournament['recurringPatternType']
  }
];

export default recurringOptions;
